import React from 'react';
import ReactDOM from 'react-dom';
import querystring from 'querystring';

import * as Types from 'types';
import { requestArtwork } from 'features/artworks/api';
import { PlaylistPlayer, artworkToPlaylist } from 'artworkPlayer';
import { ChromecastProvider } from 'context/ChromecastContext';

declare var EMBEDDED_PLAYER_OPTIONS: {
  artwork_id: number;
  autoplay: boolean;
  branding: boolean;
  fullscreen: boolean;
  mute: boolean;
  controls: boolean;
  purchase: boolean;
};

const el = document.getElementsByClassName('js-artwork-player')[0];

requestArtwork(EMBEDDED_PLAYER_OPTIONS.artwork_id).then((artwork) => {
  const playlist = artworkToPlaylist(artwork);
  ReactDOM.render(
    <ChromecastProvider>
      <PlaylistPlayer playlist={playlist} options={EMBEDDED_PLAYER_OPTIONS} />,
    </ChromecastProvider>,
    el,
  );
});

const params = querystring.decode(document.location.pathname);
